/**
 * Test Demo 校区：给测试 / 演示账号用的（见 AGENTS.md「测试账号」），不是真实校区。
 *
 * 测试模块（Test Management、Test Response 等）的界面里一律不显示它 —— 录成绩时老师误点
 * 「Test Demo」，这个学生的报告就会被分到一个不存在的校区组里。按 id 判断，改名也不受影响。
 */
export const TEST_DEMO_CAMPUS_ID = '3836257f-7081-475f-869f-7ae7c2121d9f';

export const isTestDemoCampusId = campusId => campusId === TEST_DEMO_CAMPUS_ID;

export const withoutTestDemoCampus = campuses => (campuses || []).filter(campus => !isTestDemoCampusId(campus?.id));
